// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { stringMustBeNumber } from 'validators/common'

const validate = v => {
  // Since redux-form v8, first render of the form does not have the actual initial values.
  // https://github.com/redux-form/redux-form/issues/4344
  if (Object.keys(v).length === 0) {
    return
  }

  const err = {}

  err.diameter = stringMustBeNumber(v.diameter)

  return err
}

export default validate
